import { __rest } from "tslib";
import * as React from 'react';
import Slider from 'react-slick';
const CompareFaresSlider = (_a) => {
    var { children, pushSlider } = _a, props = __rest(_a, ["children", "pushSlider"]);
    const sliderSettings = Object.assign(Object.assign({}, props), { slidesToShow: 3 });
    return (React.createElement(Slider, Object.assign({}, sliderSettings, { ref: pushSlider }), children));
};
export default CompareFaresSlider;
